import "./App.css";
// import "antd/dist/antd.min.css";
import AllRoutes from "./routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "styled-components";
import { ConfigProvider } from "antd";

const styledTheme = {
	button: `rgb(201, 218, 248)`,
};

const antdTheme = {
	token: {
		colorPrimary: '#4a6fa5',
		borderRadius: 6,
	},
};

function App() {
	return (
		<div className='App'>
			<ConfigProvider theme={antdTheme}>
				<ThemeProvider theme={styledTheme}>
					<AllRoutes />
					<ToastContainer />
				</ThemeProvider>
			</ConfigProvider>
		</div>
	);
}

export default App;
